<script>
    import { Bar } from 'vue-chartjs'
    import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

    export default {
        extends: Bar,
        props: ['height', 'dashboard'],
        mounted () {
            let data = [];
            let labels = [];
            let n = this.dashboard.next30DaysChekins.length;
            for (let d in this.dashboard.next30DaysChekins) {
                data.push(this.dashboard.next30DaysChekins[d]);
                labels.push(d);
            }
            const datasets = [
                {
                    label: 'Заезды',
                    backgroundColor: 'rgba(255,255,255,.3)',
                    borderColor: 'transparent',
                    data: data
                }
            ]
            this.renderChart(
                {
                    labels: labels,
                    datasets: datasets
                },
                {
                    tooltips: {
                        enabled: false,
                        custom: CustomTooltips
                    },
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    scales: {
                        xAxes: [{
                            display: false,
                            categoryPercentage: 1,
                            barPercentage: 0.5
                        }],
                        yAxes: [{
                            display: false
                        }]
                    }
                }
            )
        }
    }
</script>
